import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OpcionesRequest } from '@shared/interfaces/request/opciones';
import { Variables } from '@pages/fabrica-credito/interfaces/variables';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


export interface Response {
    data: any;
    exito: number;
    message: string;
}

const httpOption = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

@Injectable({
  providedIn: 'root'
})
export class VariablesService {

  
  private _url = environment.apiBaseUrl + 'api/Variables/';

  constructor(private _http: HttpClient) {}

  read(clavePerfil: number) {
    const url = `${this._url}${clavePerfil}`;
    return this._http.get<Response>(url);
  }

  create(model: Variables): Observable<Response> {
    let url: string = this._url + 'Create' ;
    return this._http.post<Response>(url, model, httpOption);
  }
  update(model: Variables): Observable<Response> {
    let url: string = this._url + 'Update' ;
    return this._http.put<Response>(url, model, httpOption);
  }

  delete(model: Variables): Observable<Response> {
    let url: string = this._url + 'Delete' ;
    return this._http.request<Response>('delete', url, {
      body: model,
    });
  }

  opciones(model: OpcionesRequest) {
    const url = environment.apiBaseUrl + 'api/Opciones/load';
    return this._http.post<Response>(url, model, httpOption);
  }
}
